import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function IntroRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    // Generate session token and redirect to proper intro flow
    const sessionToken = crypto.randomUUID();
    navigate(`/career-discovery/intro/${sessionToken}`, { replace: true });
  }, [navigate]);

  // Show loading state while redirecting
  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-primary/5 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Starting your career assessment...</p>
      </div>
    </div>
  );
}